{
  "password-form": {
    "text": {
      "password": "Heslo",
      "password-confirmation": "Potvrzení hesla"
    }
  }
}
